module.exports = __webpack_public_path__ + "static/media/texture (1).9d69609c.jpg";